import { Store } from 'vuex'
import moment from 'moment'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.GoogleConfigurationUpdated',
    callback: (config: KwixeoGoogle.Configuration): void => {
      const stored = store.state.google.config
      if (!stored || moment(stored.updated_at).isBefore(config.updated_at)) {
        store.dispatch('google/updateConfig', config)
      }
    }
  }
])
